import type React from 'react'
import ReactDOM from 'react-dom'

interface PortalProps {
  anchorEl?: React.RefObject<Nullable<HTMLElement>>['current']
  children: NonNullable<React.ReactNode>
}

/**
 * Component to render its children into the referenced element
 * @param anchorEl (optional) reference of HTML element of destination
 * @param children Child element
 */
export function Portal({ anchorEl, children }: PortalProps) {
  if (!anchorEl) {
    return children
  }
  return ReactDOM.createPortal(children, anchorEl)
}
